function Header(props) {
  return <div className="mb-4 flex justify-between items-start">
    <div>
      <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent mb-2">{props.title}</h1>
      <p className="text-sm text-blue-300">
        {props.reportType === 'monthly' ? `${props.monthYear.month} ${props.monthYear.year}` : props.monthYear.year}
      </p>
    </div>
    <button
      onClick={props.onTypeChange}
      className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 hover:bg-slate-800 backdrop-blur-sm border border-slate-700/50 p-6 rounded-2xl"
    >
      Switch to {props.reportType === 'monthly' ? 'Annual' : 'Monthly'} Report
    </button>
  </div>
}

export default Header;
